import(/* webpackMode: "eager" */ "/var/www/apect/src/app/forums/page.tsx");
